module.exports = __webpack_public_path__ + "static/media/nato_strap_stone_canvas.d31fb0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nato_strap_stone_canvas.png
// module id = 117
// module chunks = 0